import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["panel"]

  close() {
    this.panelTarget.remove();
  }

  closeWithEscape(event) {
    if (event.keyCode == 27) {
      this.close();
    }
  }

}